import React from 'react';
import './GenericChipComp.css';

const GenericChipComp = ({ score, otherTxt }) => {
  const getScoreClass = () => {
    if (score >= 7) return 'generiChipComp high';
    if (score >= 5) return 'generiChipComp medium';
    return 'generiChipComp low';
  };

  return (
    otherTxt ? (
      <div className="generiChipComp high">
        {otherTxt}
      </div>
    ) : (
      <div className={getScoreClass()}>
        Impact Score: {score}/10
      </div>
    )
  );
};

export default GenericChipComp;
